import React from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { UpdatePrimaryPhoneNumberValidationSchema } from 'validations/profile/security';

// components
import InnerForm from './InnerForm';
import {
  Text,
  Form,
  ModalDialog,
  RequiredPropsForFormModel,
  RequiredPropsForModalDialogModel,
} from '@ui';

export interface FormValuesModel {
  phone: string;
}

type IProps = RequiredPropsForModalDialogModel &
  RequiredPropsForFormModel<FormValuesModel>;

const UpdatePrimaryPhoneNumberModal = ({
  isVisible,
  initialValues,
  onSubmit,
  closeCallback,
}: IProps) => {
  const { t } = useTranslation('profile');

  return (
    <Form<FormValuesModel>
      enableReinitialize
      onSubmit={onSubmit}
      initialValues={isVisible ? initialValues : null}
      validationSchema={UpdatePrimaryPhoneNumberValidationSchema}
      renderForm={
        <ModalDialog
          width={600}
          closeModalAfterSubmit={false}
          title={t('security.update_primary_phone_number.modal_dialog.title')}
          isVisible={isVisible}
          closeCallback={closeCallback}
        >
          <StyledText>
            {t('security.update_primary_phone_number.modal_dialog.description')}
          </StyledText>
          <InnerForm />
        </ModalDialog>
      }
    />
  );
};

const StyledText = styled(Text)`
  margin-bottom: ${({ theme }) => theme.marginXs};
`;

export default UpdatePrimaryPhoneNumberModal;
